import {IConfig} from "ngx-mask";

export const maskConfig: Partial<IConfig> = {
  patterns:{
    '1':{ pattern: new RegExp('[1-9]')},
    '0':{ pattern: new RegExp('[0-9]')},
    '9':{ pattern: new RegExp('[0-9]')}
  },
};
